export default __webpack_public_path__ + "static/media/avatar_lion5.d8aaf82c.mp3";